import { MutationCache, QueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import i18n from 'i18next'

import { isPlanLimitError } from './utils/errors'

export const queryClient = new QueryClient({
	mutationCache: new MutationCache({
		onError: error => {
			if (isPlanLimitError(error)) {
				toast.error(i18n.t('app:plan_limit_reached'))
			}
		}
	}),
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5,
			retry: false
		}
	}
})
